import makeStyles from '@mui/styles/makeStyles';
const datePickerStyles = makeStyles(({ palette, shadows, transitions }) => ({
    container: {
        marginRight: 15,
    },
    root: {
        height: 51,
        border: 'none',
        '& fieldset': {
            top: 0,
            borderColor: palette.grey[400],
        },
        '& legend': {
            display: 'none',
        },
        '&:hover': {
            '& fieldset': {
                border: '1px solid',
                borderColor: palette.common.black,
            },
        },
        '&.Mui-focused': {
            '& fieldset': {
                borderColor: palette.primary.main,
            },
        },
    },
    iconButton: {
        color: palette.primary.main,
    },
    input: {
        border: 'none',
        color: palette.common.black,
    },
    inputLabel: {
        marginBottom: 3,
        color: palette.common.black,
    },
    pickerRoot: {
        boxShadow: shadows[2],
        transition: transitions.create('box-shadow', {
            duration: transitions.duration.short,
            delay: 0,
        }),
    },
    helper: {
        color: palette.error.main,
    },
    noBorderRadius: {
        borderRadius: 0,
    },
    error: {
        '& fieldset': {
            borderColor: palette.error.main,
        },
    },
}), { name: 'Common_DatePicker' });
export default datePickerStyles;
//# sourceMappingURL=datePicker.styles.js.map